<template>
   <div class="testing ">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
         <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >历年试卷</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="testing-box main">
          <div v-for="(item,index) in workList" :key="index">
           <div class="new" :class="{'share':item.length>=5}">
            <div class="menu">
                <div class="text pointer">
                  <div class="paragraph"  v-for="(items,indexs) in item"  @click="getoDetail(items)" :key="indexs">
                    <p class="date-par">{{items.title}}</p>
                    <p class="date-days">{{handleTimeOne(items.createTime)}}</p><!-- {{shijiantime1(createTime)}} -->
                  </div>
              </div>
            </div>
          </div>
        </div>
          <!-- <div style="border-bottom:0;" class="new border">
            <div class="menu">
                <div class="text pointer">
                  <div class="paragraph"  v-for="(item,index) in workList2"  @click="getoDetail(item)" :key="index">
                    <p class="date-par">{{item.title}}</p>
                    <p class="date-days">{{handleTimeOne(item.createTime)}}</p>
                  </div>
              </div>
            </div>
           </div> -->
           <div class="more-btn" @click="getNewsOutlineList()" v-show="showBtn">
                   查看更多
               </div>
               <div class="nothing" v-show="!showBtn" >
                   <hr><span>已无更多</span><hr>
               </div>
        </div>
        <footer-view></footer-view>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
          showBtn:true,
          currentPage:1,
            workList:[],
            workList2:[],
        }
    },
    computed:{
    },
    methods: { 
      // 按数量分组数组
        groupingArray(data, num) {
          let result = [];
          for(var i=0;i<data.length;i+=num){
            result.push(data.slice(i,i+num));
          }
          return result;
        },
      async getNewsOutlineList(){
        //type :通知公告4  考试大纲5  考试教材6  历年试卷7   师资培训8  组考单位9
        let params = {
                clazz:7,
                pageNum:this.currentPage++,
                pageSize:5,
            }
            let resData = await Api.Home.getNewsList(params);
            if(resData.rows.length === 0) {
                this.showBtn = false;
            } else {
              this.workList.push(resData.rows);
            }

            //  this.workList2 = this.workList2.concat(resData.rows.filter((item,index) => index>=1));
          //   resData.rows.forEach( (item, index)=> {
          //     if (index % 2) {
          //       this.workList1= this.workList1.concat(item);
          //     } else {
          //       this.workList2 = this.workList2.concat(item);
          //     }
          // })

            // this.workList1 = this.workList1.concat(resData.rows);
            // this.workList2 = this.workList2.concat(resData.rows);
        },
       
       
        async getoDetail(item) {
             if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
            let msg = {id:item.dId,type:item.clazz}
            this.$router.push('/list/testing/detail/'+item.dId ,msg)
            // Common.goPage(this, '/news/work/'+item.articleId,msg)
            }
        }
        
        
    },
    mounted() {
      this.getNewsOutlineList()
        // this.getLinks();
        // this.getWorkList();
    },
    beforeDestroy() {
    if(this.timer) {
        clearInterval(this.timer);
    }
}
}
</script>

<style lang="less" scoped>
 @import "./less/news_common.less";
  @basisColor:#900000;
  @bgColor:#eef3f6;
  @white:#fff;
  .testing {
    background-color: @white;
    // height: 700px;

    .main {
        width: 1200px;
        margin: 0 auto;
    }
    .border {
      border-bottom:0;
    }
     .new {
      background-color: #fff;
      // width: 1200px;
      // margin: 0 auto 20px;
      // border-bottom:1px dashed #888;
      // display: flex;
      // padding:20px 0;

      // .left {
      //   cursor: pointer;
      //   position: relative;
      //   width: 560px;
      //     height: 450px;
      //     padding:30px;
      //     .new-border {
      //       position: absolute;
      //       bottom:8px;
      //       left:9px;
      //       width: 516px;
      //       height: 420px;
      //       border:15px solid #e1eafe;
      //   }
      //   img {
      //     width: 100%;
      //     height: 100%;
      //   }
      // }
      .menu {
        padding:30px;
        .new-title {
          padding-bottom:10px;
          border-bottom: 1px solid #F0EEEE;
          img {
            width: 23px;
            height: 27px;
          }
          .new-box {
            // color:#457CF8;
            // font-size:35px;
            // font-family:SimHei;
            // font-weight:400;
            
          }
          .work {
            
            // font-size:22px;
            font-weight:400;
            color:#333333;
            // padding-bottom:10px;
            margin-left:14px;
            // margin-bottom:10px;
            // border-left:1px solid #666666;
          }
          .more {
            // float:right;
            // margin-top:15px;
            font-size:14px;
           
            color:#999999;
            cursor: pointer;
          }
        }
        .message {
          display:flex;
          margin-top:13px;
  
          .date {
            width: 215px;
            height: 112px;
            text-align: center;
            img {
              width: 100%;
              height: 100%;
            }
            
            // .day {
            //     font-size:25px;
            //     font-family:Adobe Heiti Std;
            //     font-weight:bold;
            //     padding:15px 0;
            //     color:rgba(102,102,102,1);
            //     border:1px solid #666666;
            //   }
            // .month {
            //   font-size:16px;
            //   font-family:Adobe Heiti Std;
            //   font-weight:bold;
            //   padding:15px 0;
            //   color:rgba(255,255,255,1);
            //   background-color: #666666;
            // }
  
          }
          .table{
            cursor: pointer;
            flex: 1;
            padding-left:30px; 

            // &:hover .table-pa ,
            // &:hover .table-pas {
            //   color: #114dd7;
            // }
            .table-pa {
              span {
                display: inline-block;
                color: #FFFFFF;
                background-color:#CC4C4D;
                padding:0 10px;
                margin-right:5px;
              }
              padding-top:12px;
              font-size: 16px;
              font-weight: bold;
              color: #333333;
              overflow:hidden; 
              text-overflow:ellipsis;
              display:-webkit-box; 
              -webkit-box-orient:vertical;
              -webkit-line-clamp:2; 
            }
            .table-pas {
              padding-top:15px;
              font-size: 12px;
              color:#999999;
              overflow:hidden; 
              text-overflow:ellipsis;
              display:-webkit-box; 
              -webkit-box-orient:vertical;
              -webkit-line-clamp:2; 
            }
            
          }
        }
        .text {
          font-size: 16px;
          color:#151515;

          

          .paragraph {
            cursor: pointer;
            padding:24px 0 0 0;
            line-height: 20px;
            height: 20px;

          //   &:hover .date-par,
          //   &:hover .date-days {
          //     color: #114dd7;
          // }
              .date-par {
                float: left;
                overflow:hidden; 
                text-overflow:ellipsis;
                display:-webkit-box; 
                -webkit-box-orient:vertical;
                -webkit-line-clamp:1; 
                width: 80%;
              }
              .date-days {
                float: right;
                font-size: 14px;
                color: #999999;
            }
          }
          
        }
      }

       
    }
    .share {
        border-bottom:1px dashed #888;
      }
     .more-btn {
            display: block;
    
            margin: 50px auto 28px;
            border: 1px solid @basisColor;
            border-radius: 3px;
            width: 200px;
            line-height: 40px;
            
            font-size: 12px;
            
            color: @basisColor;
    
            text-align: center;
            cursor: pointer;
        }

        .nothing {
            display: block;
    
            margin: 50px auto 28px;
            // width: 200px;
            line-height: 40px;
            
            font-size: 14px;
            
            color: #a1a1a1;
    
            text-align: center;
            cursor: pointer;

            hr{
                width:200px;
                display:inline-block;
                vertical-align:middle;
                border-color: #eee;
            }
            span{
              padding: 20px;
            }
        }
  }
</style>